import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Chip } from '@breathelife/mui';

import { ParticipantRole } from '@zinnia/form-engine-sdk';
import styled from '../../Styles/themed-styled-components';

type ParticipantRoleBadgeProps = {
  role: ParticipantRole;
};

const StyledChip = styled(Chip)`
  && {
    background-color: ${(props) => props.theme.colors.blue[20]};
    color: ${(props) => props.theme.colors.blue[50]};
    border-color: ${(props) => props.theme.colors.blue[50]};
  }
`;

export function ParticipantRoleBadge(props: ParticipantRoleBadgeProps): ReactElement {
  const { role } = props;

  const { t } = useTranslation();

  return <StyledChip key={role} label={t(`participantRole.${role}`)} size='small' variant='outlined' color='info' />;
}
